import { render, staticRenderFns } from "./Attendance.vue?vue&type=template&id=c969b18a&"
import script from "./Attendance.vue?vue&type=script&lang=ts&"
export * from "./Attendance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports